import useTranslation from 'next-translate/useTranslation';

import Link from 'components/common/Link';

import { BlogCardProps } from 'interfaces/cms/content';

function BlogCard({
  author,
  publishedDate,
  authorDateColor,
  url,
  linkRel,
  title,
  titleColor,
  subtitle,
  subtitleColor,
  thumbnailUrl,
}: BlogCardProps) {
  const { t } = useTranslation('common');

  return (
    <Link
      href={url}
      rel={linkRel}
      isExternalLink
      className="max-w-[26.25rem] mx-auto"
    >
      {
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={thumbnailUrl}
          alt={title}
          className="rounded-[1rem] mb-[1.25rem]"
        />
      }

      <div
        style={{ color: authorDateColor }}
        className="text-sm flex justify-between"
      >
        <span>
          {t('by')} {author}
        </span>
        <div className="flex">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 mr-1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          {publishedDate}
        </div>
      </div>

      <div
        className="mt-[0.625rem] mb-[0.3125rem] font-bold text-lg"
        style={{ color: titleColor }}
      >
        {title}
      </div>

      <span style={{ color: subtitleColor }} className="text-sm">
        {subtitle}
      </span>
    </Link>
  );
}

export default BlogCard;
